export default function ViewModeIcon({ count }) {
  const dividerCoordinates = {
    2: [{ x1: 12, y1: 3, x2: 12, y2: 21 }],
    4: [
      { x1: 12, y1: 3, x2: 12, y2: 21 },
      { x1: 3, y1: 12, x2: 21, y2: 12 },
    ],
  };

  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
      <rect x="3" y="3" width="18" height="18" fill="none" />
      {(dividerCoordinates[count] || []).map((divider) => (
        <line key={`${divider.x1}-${divider.y1}-${divider.x2}-${divider.y2}`} {...divider} />
      ))}
    </svg>
  );
}
